import React, { useState, useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { useLocation } from 'react-router';

const ScrollToTopButton: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 200);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (location.pathname.includes('/escort/')) {
    return null;
  }

  return visible ? (
    <button
      onClick={handleClick}
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 40,
        background: 'rgb(219 39 119 / 0.8)',
        color: '#fff',
        border: 'none',
        borderRadius: '50%',
        width: 44,
        height: 44,
        fontSize: 24,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        cursor: 'pointer',
      }}
      aria-label={t('accessibility.backToTop')}
    >
      ↑
    </button>
  ) : null;
};

export default ScrollToTopButton;
